// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2km4-","content":"styles_content__1YvsQ","tableWrap":"styles_tableWrap__39IKY"};